import { StoreState } from '@src/context/store';
import { ConsentPolicy } from '@wix/ambassador-site-properties-service/types';
import { isAppEnabled } from '@src/context/selectors/ui-settings';

export const getDefaultPolicy = (store: StoreState): ConsentPolicy => {
  const enabled = isAppEnabled(store);
  console.log(enabled);
  return {
    essential: true,
    analytics: !enabled,
    advertising: !enabled,
    functional: !enabled,
    dataToThirdParty: true,
  };
};
